import { ThemeProvider } from '@emotion/react';
import AppBar from '@mui/material/AppBar';
import { createTheme } from '@mui/material/styles';
import DMInput from 'components/molecules/InputText/DMInput';
import { IMessage } from 'interfaces/message.interface';
import React from 'react';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontSize: 10,
    fontFamily: ['lato'].join(','),
  },
});

type Props = {
  data: any;
  messages?: IMessage[];
};

const DMessageFooter = ({ data, messages }: Props) => {
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="fixed"
          color="primary"
          sx={{
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            paddingRight: '40px',
            paddingLeft: '30px',
            paddingTop: '22px',
            paddingBottom: '50px',
            top: 'auto',
            bottom: 0,
            height: '120px',
            justifyContent: 'start',
            backgroundColor: '#292739',
          }}
        >
          <DMInput messages={messages} mobile={true} user={data} />
        </AppBar>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default DMessageFooter;
